import React, { useState } from 'react';
import Error from '../../../ui/Error';
import Singleton from '../../../core/singleton';
import AxiosServices from '../../../services/AxiosServices';
import events from '../../../core/events';

export const ResetRegistrationNumber = props => {
    const { close } = props;
    const { getTradByKey, eventEmitter } = Singleton.getInstance();
    const [registrationNumber, setRegistrationNumber] = useState(null);
    const [error, setError] = useState(null);
    const onFormSubmit = (form) => {
        form.preventDefault();
        let attempt = () => AxiosServices.authenticate(registrationNumber).then(token => {
            eventEmitter.emit(events.ON_USER_REGISTRATION, registrationNumber);
            close();
        }).catch(error => {
            if (confirm(`${error.message}
                Try again ?
            `,)) {
                attempt();
            }
        });
        attempt();
    }
    const SubmitButton = props => <div className="modal-footer">
        <button disabled={props.disabled} type="submit" className="btn btn-primary btn-block">
            {getTradByKey('continue')} <i className="fas fa-angle-right"></i>
        </button>
    </div>

    return <>
        <div className="modal-header">
            <h5 className="modal-title">{getTradByKey('user')} {props.registrationNumber}</h5>
            <button onClick={() => close()} type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form className='reset-registration-number-submit-form' onSubmit={onFormSubmit}>
            <div className="modal-body">
                <h5>{getTradByKey('new_registration_number_user')}</h5>
                <div className="form-group">
                    <input
                        onChange={event => {
                            setRegistrationNumber(event.target.value);
                        }}
                        id="registration-number-input"
                        className="form-control"
                        aria-describedby={getTradByKey('enter_registration_number')}
                        placeholder={getTradByKey('enter_registration_number')} />
                </div>
            </div>
            <SubmitButton disabled={!(registrationNumber && registrationNumber.length > 0)} />
        </form>
        {
            (error !== null) &&
            <Error response={error}>
                <h1>{error.name} <i className="fas fa-bug"></i></h1>
                <p><strong>{error.message}</strong></p>
                <button
                    onClick={() => getTranslation()} className="btn btn-primary">Try again <i className="fas fa-history"></i>
                </button>
            </Error>
        }
    </>
}